// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import Image from 'church-theme-library/components/Image/Image'
import LoadScript from 'church-theme-library/containers/LoadScript'

class FacebookEmbed extends React.Component {
	render() {
		const { contentId, sectionId, data, translate, facebookURL } = this.props

		return (
			<div className="section-facebook-embed">
				<LoadScript
					src={ `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.1&appId=${siteData.vl_facebook_app_id}` }
				/>

				<div className="-inner">
					<div className="-text">
						<Editable
							element="h2"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="heading"
							content={ data.heading }
						/>

						<Editable
							element="p"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="content"
							content={ data.content }
						/>

						<p className="with-button">
							<a href={ facebookURL } className="button" target="_blank" rel="noopener">{ translate( 'Visit our Facebook page' ) }</a>
						</p>
					</div>

					<div className="-embed">
						<div className="fb-page" data-href={ facebookURL } data-tabs="timeline" data-small-header="true" data-adapt-container-width="true" data-width="500" data-hide-cover="true" data-show-facepile="false" lazy="true"></div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		facebookURL: state.site.facebookURL
	}
}

export default localize(
	connect( mapStateToProps )( FacebookEmbed )
)
